module.exports = __webpack_public_path__ + "static/media/EuclidCircularB-Regular.b004e2c2.woff2";